const types = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  COMMIT_REQUEST: 'UPDATE_REQUEST',
  COMMIT_SUCCESS: 'UPDATE_SUCCESS',
  COMMIT_FAILURE: 'UPDATE_FAILURE',
  COMMIT_INIT: 'UPDATE_INIT',

  COMMON_REQUEST: 'COMMON_REQUEST',
  COMMON_SUCCESS: 'COMMON_SUCCESS',
  COMMON_FAILURE: 'COMMON_FAILURE',
  COMMON_INIT: 'COMMON_INIT',

  QUERY_REQUEST: 'QUERY_REQUEST',
  QUERY_SUCCESS: 'QUERY_SUCCESS',
  QUERY_FAILURE: 'QUERY_FAILURE',
  QUERY_INIT: 'QUERY_INIT',

  FETCH_DETAIL_REQUEST: 'FETCH_DETAIL_REQUEST',
  FETCH_DETAIL_SUCCESS: 'FETCH_DETAIL_SUCCESS',
  FETCH_DETAIL_FAILURE: 'FETCH_DETAIL_FAILURE',
  FETCH_DETAIL_INIT: 'FETCH_DETAIL_INIT',

  FETCH_RECORD_REQUEST: 'FETCH_RECORD_REQUEST',
  FETCH_RECORD_SUCCESS: 'FETCH_RECORD_SUCCESS',
  FETCH_RECORD_FAILURE: 'FETCH_RECORD_FAILURE',
  FETCH_RECORD_INIT: 'FETCH_RECORD_INIT',

  SHARE_STATUS: 'SHARE_STATUS'
}

export default types



// WEBPACK FOOTER //
// ./src/store/constants/types.js